import { CurrentPartner } from 'components/currentPartner'
import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { TitleRow } from 'components/titleRow'
import { useCurrentAccount } from 'hooks/admin/useAuth'
import { useEventsAdmin } from 'hooks/admin/useEvents'
import { useOrganizations } from 'hooks/admin/useOrganizations'
import { useGeneratedEventId } from 'hooks/admin/useWizard/useGenerateEventId'
import React from 'react'
import { useParams } from 'react-router-dom'

import { Container, ContainerWrapper } from './events.style'
import { EventListAdmin } from './list/eventListAdmin'

export const EventsAdmin = () => {
    const { partnerId } = useParams<{ partnerId?: string }>()
    const { currentAccount, isLoadingCurrentAccount, errorCurrentAccount } = useCurrentAccount()
    const { data, linkToForm, isLoading, error, tableConfig, handleEdit, handleDelete, handleSearch } = useEventsAdmin(partnerId)

    // NOTE: Clears the generated eventid from sessions storage as this is the point where we can start adding a new event, and where we end up after its added
    const { clearGeneratedEventId } = useGeneratedEventId()

    React.useEffect(() => {
        clearGeneratedEventId()
    }, [clearGeneratedEventId])

    const { data: orgData } = useOrganizations()
    const partnerName = React.useMemo(() => orgData?.find((org) => org.org_id === partnerId)?.name, [orgData, partnerId])

    const isEventsLoading = isLoading || isLoadingCurrentAccount
    const hasEvents = data && data.length > 0 && currentAccount

    return (
        <Container>
            <ContainerWrapper>
                {partnerId && partnerName && <CurrentPartner partnerName={partnerName}></CurrentPartner>}
                <TitleRow
                    configData={tableConfig.titleRow}
                    onSearch={handleSearch}
                    linkTo={linkToForm}
                    linkLabel={tableConfig.titleRow.buttonLabel}
                />
                <LoadingContainer isLoading={isEventsLoading} error={error || errorCurrentAccount}>
                    {hasEvents ? (
                        <EventListAdmin data={data} onEdit={handleEdit} onDelete={handleDelete} />
                    ) : (
                        <PlaceholderContainer>
                            <p>Jelenleg nincsenek események. Hozz létre újat!</p>
                        </PlaceholderContainer>
                    )}
                </LoadingContainer>
            </ContainerWrapper>
        </Container>
    )
}
